import {
    Component,
    Injector,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseControlValueAccessor} from '../../../../shared/core/base-control-value-accessor';
import {SectionState} from '../../../../shared/components/section/section.model';
import {ContentieuxSocial} from '../../../../entities/contentieux-social';
import {DepotRequeteState} from '../../../depot-requete-state.model';
import {RadioFieldsetItem} from '../../../radio-fieldset/radio-fieldset-item.interface';
import {DraftDepotRequeteService} from '../../../draft-depot-requete.service';
import {FileUploaderModel} from '../../../../shared/components/file-uploader/file-uploader.model';
import {
    PieceActeAttaque,
    PieceComplementaire,
    PieceComplementaireOrigineType,
    PieceJointType,
    PieceReclamationPrealable,
    PieceRequete
} from '../../../../entities/piece-jointe';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TypeRaisonContestation} from '../../../../entities/type-raison-contestation';
import {Subscription} from 'rxjs';
import {ParametersService} from '../../../../shared/services/parameters.service';
import {FileUploaderComponent} from '../../../../shared/components/file-uploader/file-uploader.component';
import {DragulaService} from 'ng2-dragula';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {TypeRaisonInvalidationTitre} from '../../../../entities/type-raison-invalidation-titre';
import {TypeRaisonAvisDimpositionIrregulier} from '../../../../entities/type-raison-avis-dimposition-irregulier';
import { TypePrejudiceEvaluableEnArgent } from '../../../../entities/type-prejudice-evaluable-en-argent';
import { ReclamationPrealableComponent } from '../reclamation-prealable/reclamation-prealable.component';

@Component({
    selector: 'jhi-contentieux-social-section',
    templateUrl: './contentieux-social-section.component.html',
    styleUrls: ['./contentieux-social-section.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ContentieuxSocialSectionComponent,
            multi: true
        }
    ]
})
export class ContentieuxSocialSectionComponent extends BaseControlValueAccessor implements OnInit, OnDestroy, OnChanges {

    @Input()
    depotRequeteState: DepotRequeteState;

    @Input()
    sociauxDALOChampsObligatoiresFilled: any;

    @Input()
    litigeLieDecisionChampsObligatoiresFilled: any;

    @Input()
    reclamerUneSommeChampsObligatoiresFilled: any;

    @Input()
    contesterUneSommeChampsObligatoiresFilled: any;

    @Input()
    indemnisationChampsObligatoiresFilled: any;

    @Input()
    requeteRedigeePieceComplementaireLebelleFilled: any;

    @ViewChild(ReclamationPrealableComponent) reclamationPrealableComponent: ReclamationPrealableComponent;

    @ViewChild('pieceMIAdder') pieceMIAdder: FileUploaderComponent;
    @ViewChild('pieceMAAdder') pieceMAAdder: FileUploaderComponent;
    @ViewChild('pieceSommeDueAdder') pieceSommeDueAdder: FileUploaderComponent;
    @ViewChild('pieceMontantDuAdder') pieceMontantDuAdder: FileUploaderComponent;
    @ViewChild('pieceAIECAdder') pieceAIECAdder: FileUploaderComponent;
    @ViewChild('pieceAIIAAdder') pieceAIIAAdder: FileUploaderComponent;
    @ViewChild('piecePrecisionPrejudiceAdder') piecePrecisionPrejudiceAdder: FileUploaderComponent;
    @ViewChild('pieceRequeteRedigeeJustAdder') pieceRequeteRedigeeJustAdder: FileUploaderComponent;

    private modalReference: any;

    public demandAnnulationDecisionChecked: any;

    public markReclamationPrealableAsUntouched: boolean;

    public get uploadUrl(): string {
        return this.draftDepotRequeteService.buildUploadUrl();
    }
    public showSouhaitSection = false;
    public showRapoSection = true;
    public showNomAdministrationsSection = true;
    public showIntituleDemandeSection = true;
    public showTypeLitigeSection = false;
    public showSommeDueSection = false;
    public showMontantDuSection = false;
    public showReclamationPrealableSection = false;
    public showDecisionAttaqueSection = true;
    public showMotifSection = true;
    public showContexteInterventionDecision = false;
    public showRaisonsContesterDecisionSection = false;
    public showFaitConduitLitigeSection = false;
    public showTypeActeEmisSection = false;
    public showAvisImpositionIrregulerSection = false;
    public showRaisonPasPayerImpotSection = false;
    public showTitreEmisIrregulerSection = false;
    public showDALOConclusionSection = true;
    public showConclusionLitigeAdminSection = false;
    public showConclusionReclamerSommeSection = false;
    public showConclusionAvisImpositionImpotSection = false;
    public showConclusionTitreEmisIrregulerSection = false;
    public showFaitConduitSituationReparationSection = false;
    public showTypePrejudiceEvaluableEnArgentSection = false;
    public showPrecisionPrejudiceSection = false;
    public showOriginePrejudiceSection = false;
    public showConclusionIndemnisationSection = false;
    public showRequeteRedigeeSection = false;
    public showRequeteRedigeeJustificatifsSection = false;

    public sections: { [key: string]: SectionState } = {
        rapo: { index: 3, isToggleable: false},
        souhait: { index: 3, isToggleable: false},
        typeLitige: { index: 4, isToggleable: false},
        hasDecisionAttaque: { index: 4, isToggleable: false},
        requeteRedigeeDecisionAttaque: { index: 4, isToggleable: false},
        reclamationPrealable: { index: 5, isToggleable: false},
        administrationDecision: { index: 5, isToggleable: false},
        depotRequeteRedigee: { index: 5, isToggleable: false},
        intituleDemande: { index: 6, isToggleable: false},
        requeteRedigeeJustificatifs: { index: 6, isToggleable: false},
        motifDemande: { index: 7, isToggleable: false},
        contexteInterventionDecision: { index: 7, isToggleable: false},
        faitConduitLitigeSection: {index: 8, isToggleable: false},
        conclusionDALO: { index: 8, isToggleable: false},
        raisonsContesterDecision: { index: 8, isToggleable: false},
        faitConduitSituationReparationSection : { index: 8, isToggleable: false},
        typeActeEmisSection: { index: 9, isToggleable: false},
        conclusionLitigeAdmin: { index: 9, isToggleable: false},
        typePrejudiceEvaluableEnArgentSection: { index: 9, isToggleable: false},
        sommeDueSection: { index: 9, isToggleable: false},
        avisImpositionIrregulerSection: { index: 10, isToggleable: false},
        titreEmisIrregulerSection: {index: 10, isToggleable: false},
        precisionPrejudiceSection: { index: 10, isToggleable: false},
        montantDuSection: { index: 10, isToggleable: false},
        conclusionTitreEmisIrregulerSection: { index: 11, isToggleable: false},
        erreurCalculMontantSection: { index: 11, isToggleable: false},
        raisonPasPayerImpotSection: { index: 11, isToggleable: false},
        originePrejudiceSection: { index: 11, isToggleable: false},
        conclusionReclamerSommeSection: { index: 11, isToggleable: false},
        conclusionAvisImpositionImpotSection: { index: 12, isToggleable: false},
        conclusionIndemnisationSection: { index: 12, isToggleable: false}
    };

    public souhaitTexts: RadioFieldsetItem[] = [
        {
            value: 'souhait 1',
            title: 'litige lié à une décision de l\'administration',
            description: 'Remplir le formulaire : litige lié à une décision de l\'administration'
        },
        {
            value: 'souhait 2',
            title: 'litige lié à une somme d\'argent',
            description: 'Remplir le formulaire : litige lié à une somme d\'argent'
        },
        {
            value: 'souhait 3',
            title: 'Deposer requete',
            description: 'Déposer une requête que vous avez rédigée'
        }
    ];

    public typeLitigeTexts: RadioFieldsetItem[] = [
        {
            value: 'type 1',
            title: 'Vous réclamez une somme d\'argent à l\'administration',
            description: ''
        },
        {
            value: 'type 2',
            title: 'Vous contestez une somme d\'argent réclamée par l\'administration',
            description: ''
        },
        {
            value: 'type 3',
            title: 'Vous réclamez une indemnisation pour une faute commise par l\'administration ou une situation anormale ' +
             '(la faute peut relever d\'une action ou d\'une inaction de l\'administration)',
            description: `trou présent dans la chaussée, défaut de surveillance d'un hôpital, infection nosocomiale, etc.`
        }
    ];

    public typeActeEmisTexts: RadioFieldsetItem[] = [
        {
            value: 'acte 1',
            title: 'Un avis d\'imposition',
            description: 'impôt sur le revenu, taxe d\'habitation, taxe foncière, etc.'
        },
        {
            value: 'acte 2',
            title: 'Un titre de recette, un avis de somme à payer, ou autre',
            description: 'rappel, mise en demeure, facture d\'hôpital, frais de cantine, etc'
        }
    ];

    public showLitigeAvocat: boolean;
    public typeRaisonContestations: Array<TypeRaisonContestation> = [];

    public noneRCchecked: boolean;

    public typeRaisonInvalidationTitres: Array<TypeRaisonInvalidationTitre> = [];

    public noneRITchecked: boolean;

    public typeRaisonAvisDimpositionIrreguliers: Array<TypeRaisonAvisDimpositionIrregulier> = [];

    public noneRADIchecked: boolean;

    public typePrejudiceEvaluableEnArgents: Array<TypePrejudiceEvaluableEnArgent> = [];

    public nonePEEAchecked: boolean;

    public typeActeAdderLabel: string;

    // part of pieces complémentaires, for front only
    public pieceComplementaireRAPO: PieceComplementaire | undefined;

    public pieceComplementaireMalInterprete: Array<PieceComplementaire>;

    public pieceComplementaireMalApprecie: Array<PieceComplementaire>;

    public pieceComplementaireSommeDue: Array<PieceComplementaire>;

    public pieceComplementaireMontantDu: Array<PieceComplementaire>;

    public pieceComplmentaireAvisImpositionInfondeeEtAutre: Array<PieceComplementaire>;

    public pieceComplementairePrecisionPrejudice: Array<PieceComplementaire>;

    public pieceComplementaireRequeteRedigeeJust: Array<PieceComplementaire>;

    private subscription: Subscription;
    private dragSubscription: Subscription;
    private dropSubscription: Subscription;

    public maxNumberJointsComplementaryPieces = 98;
    public showLengthWarningForFileName = false;
    public maxFileNameWithoutExtensionLength: number;
    public maxFileSize: number;
    public maxReclamationPrealablesForMerge: number;
    public maxActeAttaquesForMerge: number;
    public actualFileNameLength = 0;

    // --- drag n drop keyboard accessible
    public selectedItemMI = null;
    public selectedItemMA = null;
    public selectedItemSommeDue = null;
    public selectedItemMontantDu = null;
    public selectedItemAIEC = null;
    public selectedItemAIIA = null;
    public selectedItemPrecisionPrejudice = null;
    public selectedItemRRJ = null;

    public contentieuxSocial = new ContentieuxSocial();

    constructor(injector: Injector,
        private dragulaService: DragulaService,
        private liveAnnouncer: LiveAnnouncer,
        private draftDepotRequeteService: DraftDepotRequeteService,
        private modalService: NgbModal,
        private parametersService: ParametersService) {
        super(injector);
        if (this.dragulaService.find('piecesComplementairesBagMI') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagMI', {});
        }
        if (this.dragulaService.find('piecesComplementairesBagMA') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagMA', {});
        }
        if (this.dragulaService.find('piecesComplementairesBagSommeDue') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagSommeDue', {});
        }
        if (this.dragulaService.find('piecesComplementairesBagMontantDu') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagMontantDu', {});
        }
        if (this.dragulaService.find('piecesComplementairesBagAvisImpositionInfondeeEtAutre') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagAvisImpositionInfondeeEtAutre', {});
        }
        if (this.dragulaService.find('piecesComplementairesBagPrecisionPrejudice') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagPrecisionPrejudice', {});
        }
        if (this.dragulaService.find('piecesComplementairesBagRequeteRedigeeJustificatifs') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagRequeteRedigeeJustificatifs', {});
        }

        this.dropSubscription = this.dragulaService.out.subscribe(() => {
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplementaireMalInterprete);
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplementaireMalApprecie);
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplementaireSommeDue);
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplementaireMontantDu);
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplmentaireAvisImpositionInfondeeEtAutre);
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplementairePrecisionPrejudice);
            this.depotRequeteState.piecesComplementaires.push(...this.pieceComplementaireRequeteRedigeeJust);
            this.liveAnnouncer.announce('élément relaché');
        });

        this.dragSubscription = this.dragulaService.drag.subscribe(() => {
          this.liveAnnouncer.announce('élément selectionné');
        });
    }
    ngOnInit(): void {
        console.log('ngOnInit');
    }

    // initiation is done here
    writeValue(_value: ContentieuxSocial): void {
        console.log('writeValue | depotRequeteState.formActivated : ', this.depotRequeteState.formActivated);
        this.initPiecesComplementaires();
        this.loadChoixMultiple();
        // if config is ON, show different forms
        if (this.depotRequeteState.formActivated) {
          this.initFormWhenJurisdictionIsON();
        // if config is OFF, show only DALO form if concernContentieuxSocial when urgenceRequete is 'une procédure normale'
        } else {
            if (this.depotRequeteState.urgenceRequete && this.depotRequeteState.urgenceRequete.codeUrgence === 0) {
                if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                    this.setAllSectionsInvisible();
                } else {
                    if (!this.depotRequeteState.concernContentieuxSocial) {
                        this.setAllSectionsInvisible();
                    } else {
                        // show formulaire DALO
                        this.showSociauxDALOSections();
                    }
                }
            } else {
                this.setAllSectionsInvisible();
            }
        }
    }

    private initPiecesComplementaires(): void {
        this.pieceComplementaireMalInterprete = new Array<PieceComplementaire>();
        this.pieceComplementaireMalApprecie = new Array<PieceComplementaire>();
        this.pieceComplementaireSommeDue = new Array<PieceComplementaire>();
        this.pieceComplementaireMontantDu = new Array<PieceComplementaire>();
        this.pieceComplmentaireAvisImpositionInfondeeEtAutre = new Array<PieceComplementaire>();
        this.pieceComplementairePrecisionPrejudice = new Array<PieceComplementaire>();
        this.pieceComplementaireRequeteRedigeeJust = new Array<PieceComplementaire>();

        this.pieceComplementaireRAPO =
        this.depotRequeteState.piecesComplementaires.find(pc =>
        pc.complementaryFileOriginType === PieceComplementaireOrigineType.RAPO);

        this.pieceComplementaireMalInterprete =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_INTERPRETE);

        this.pieceComplementaireMalApprecie =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_APPRECIE);

        this.pieceComplementaireSommeDue =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.SOMME_DUE);
        this.pieceComplementaireMontantDu =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MONTANT_DU);

        this.pieceComplmentaireAvisImpositionInfondeeEtAutre =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE);

        this.pieceComplementairePrecisionPrejudice =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.PRECISION_PREJUDICE);

        this.pieceComplementaireRequeteRedigeeJust =
        this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF);
    }

    private loadChoixMultiple(): void {
        this.subscription = this.parametersService.getParameters()
            .subscribe(
                parameters => {
                    this.maxFileNameWithoutExtensionLength = parameters.maxFileNameWithoutExtensionLength;
                    this.maxFileSize = parameters.maxFileSize;
                    this.maxActeAttaquesForMerge = parameters.maxActeAttaquesForMerge;
                    this.maxReclamationPrealablesForMerge = parameters.maxActeAttaquesForMerge; // comme acte attaqué
                    this.typeRaisonContestations = parameters.typeRaisonContestations;
                    this.typeRaisonInvalidationTitres = parameters.typeRaisonInvalidationTitres;
                    this.typeRaisonAvisDimpositionIrreguliers = parameters.typeRaisonAvisDimpositionIrreguliers;
                    this.typePrejudiceEvaluableEnArgents = parameters.typePrejudiceEvaluableEnArgents;
                    // si requeteCS est null, nettoie les données de ces 3 listes
                    if (this.depotRequeteState && !this.depotRequeteState.requeteCS) {
                        this.clearTypeRaisonContestations();
                        this.clearTypeRaisonInvalidationTitres();
                        this.clearTypeRaisonAvisDimpositionIrreguliers();
                        this.clearTypePrejudiceEvaluableEnArgents();
                    }
                    if (this.depotRequeteState && this.depotRequeteState.requeteCS) {
                        if (!this.depotRequeteState.requeteCS.raisonContestations) {
                            this.clearTypeRaisonContestations();
                        } else {
                            this.noneRCchecked = false;
                            this.initTypeRaisonContestations();
                        }
                        if (!this.depotRequeteState.requeteCS.raisonInvalidationTitres) {
                            this.clearTypeRaisonInvalidationTitres();
                        } else {
                            this.noneRITchecked = false;
                            this.initTypeRaisonInvalidationTitres();
                        }
                        if (!this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers) {
                            this.clearTypeRaisonAvisDimpositionIrreguliers();
                        } else {
                            this.noneRADIchecked = false;
                            this.initTypeRaisonAvisDimpositionIrreguliers();
                        }
                        if (!this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents) {
                            this.clearTypePrejudiceEvaluableEnArgents();
                        } else {
                            this.nonePEEAchecked = false;
                            this.initTypePrejudiceEvaluableEnArgents();
                        }
                    }
                });
    }

    private clearTypeRaisonContestations(): void {
        this.noneRCchecked = true;
        for (const rc of this.typeRaisonContestations) {
            rc.checked = false;
            rc.detail = '';
        }
    }

    private clearTypeRaisonInvalidationTitres(): void {
        this.noneRITchecked = true;
        for (const rit of this.typeRaisonInvalidationTitres) {
            rit.checked  = false;
            rit.detail = '';
        }
    }

    private clearTypeRaisonAvisDimpositionIrreguliers(): void {
        this.noneRADIchecked = true;
        for (const ra of this.typeRaisonAvisDimpositionIrreguliers) {
            ra.checked = false;
        }
    }

    private clearTypePrejudiceEvaluableEnArgents(): void {
        this.nonePEEAchecked = true;
        for (const peea of this.typePrejudiceEvaluableEnArgents) {
            peea.checked = false;
        }
    }

    private initTypeRaisonContestations(): void {
        for (const rc of this.depotRequeteState.requeteCS.raisonContestations) {
            const typeRaison = this.typeRaisonContestations.find(trc => trc.id === rc.typeRaisonContestationId);
            if (typeRaison) {
                typeRaison.checked = true;
                typeRaison.detail = rc.detail;
            }
        }
    }

    private initTypeRaisonInvalidationTitres(): void {
        for (const rit of this.depotRequeteState.requeteCS.raisonInvalidationTitres) {
            const typeRIT = this.typeRaisonInvalidationTitres.find(t => t.id === rit.typeRaisonInvalidationTitreId);
            if (typeRIT) {
                typeRIT.checked = true;
                typeRIT.detail = rit.detail;
            }
        }
    }

    private initTypeRaisonAvisDimpositionIrreguliers(): void {
        for (const ra of this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers) {
            const typeRA = this.typeRaisonAvisDimpositionIrreguliers.find(t => t.id === ra.typeRaisonAvisDimpositionIrregulierId);
            if (typeRA) {
                typeRA.checked = true;
            }
        }
    }

    private initTypePrejudiceEvaluableEnArgents(): void {
        for (const peea of this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents) {
            const typePEEA = this.typePrejudiceEvaluableEnArgents.find(t => t.id === peea.typePrejudiceEvaluableEnArgentId);
            if (typePEEA) {
                typePEEA.checked = true;
            }
        }
    }

    private initFormWhenJurisdictionIsON(): void {
        if (this.depotRequeteState.urgenceRequete && this.depotRequeteState.urgenceRequete.codeUrgence === 0) {
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.setAllSectionsInvisibleExceptSouhait();
                if (this.depotRequeteState.requeteCS) {
                    if (this.depotRequeteState.requeteCS.souhait) {
                        this.setSectionVisibilityBySouhait(this.depotRequeteState.requeteCS.souhait);
                        if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
                            this.showLitigeAvocat = true;
                            this.showTypeLitigeSection = true;
                            this.sections.typeLitige.index = 3;
                            this.setSectionVisibilityByTypeLitige(this.depotRequeteState.requeteCS.typeLitige);
                            if (this.depotRequeteState.requeteCS.typeLitige ===
                                'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                    this.setSectionVisibilityByTypeActe(this.depotRequeteState.requeteCS.typeActe);
                            }
                        }
                    }
                }
            } else {
                if (this.depotRequeteState.concernContentieuxSocial == null) {
                    this.setAllSectionsInvisible();
                } else if (this.depotRequeteState.concernContentieuxSocial != null &&
                    !this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                    this.setSectionVisibilityBySouhait(this.depotRequeteState.requeteCS.souhait);
                    if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
                        this.showLitigeAvocat = true;
                        this.setSectionVisibilityByTypeLitige(this.depotRequeteState.requeteCS.typeLitige);
                        if (this.depotRequeteState.requeteCS.typeLitige ===
                            'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                this.setSectionVisibilityByTypeActe(this.depotRequeteState.requeteCS.typeActe);
                        }
                    }
                }
            }
        } else {
            this.setAllSectionsInvisible();
        }
    }

    private setAllSectionsInvisible() {
        this.showSouhaitSection = false;
        this.showRapoSection = false;
        this.showNomAdministrationsSection = false;
        this.showIntituleDemandeSection = false;
        this.showTypeLitigeSection = false;
        this.showReclamationPrealableSection = false;
        this.showDecisionAttaqueSection = false;
        this.showMotifSection = false;
        this.showContexteInterventionDecision = false;
        this.showRaisonsContesterDecisionSection = false;
        this.showSommeDueSection = false;
        this.showMontantDuSection = false;
        this.showFaitConduitLitigeSection = false;
        this.showTypeActeEmisSection = false;
        this.showAvisImpositionIrregulerSection = false;
        this.showRaisonPasPayerImpotSection = false;
        this.showTitreEmisIrregulerSection = false;
        this.showDALOConclusionSection = false;
        this.showConclusionLitigeAdminSection = false;
        this.showConclusionReclamerSommeSection = false;
        this.showConclusionAvisImpositionImpotSection = false;
        this.showConclusionTitreEmisIrregulerSection = false;
        this.showFaitConduitSituationReparationSection = false;
        this.showTypePrejudiceEvaluableEnArgentSection = false;
        this.showPrecisionPrejudiceSection = false;
        this.showOriginePrejudiceSection = false;
        this.showConclusionIndemnisationSection = false;
        this.showRequeteRedigeeSection = false;
        this.showRequeteRedigeeJustificatifsSection = false;
    }

    private setAllSectionsInvisibleExceptSouhait() {
        this.setAllSectionsInvisible();
        this.showSouhaitSection = true;

        this.sections.souhait.index = 2;
        if (this.depotRequeteState.requeteCS &&
            this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            this.showLitigeAvocat = true;
        } else {
            this.showLitigeAvocat = false;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log('ngOnChanges | changes.depotRequeteState.currentValue : ', changes.depotRequeteState.currentValue)
        if (changes.depotRequeteState.currentValue.urgenceRequete &&
            changes.depotRequeteState.currentValue.urgenceRequete.codeUrgence === 0) {
            this.depotRequeteState.concernContentieuxSocial = changes.depotRequeteState.currentValue.concernContentieuxSocial;
            if (this.depotRequeteState.concernContentieuxSocial) {
                Object.keys(this.sociauxDALOChampsObligatoiresFilled).forEach(v => this.sociauxDALOChampsObligatoiresFilled[v] = true);
            } else {
                Object.keys(this.litigeLieDecisionChampsObligatoiresFilled).forEach(v =>
                    this.litigeLieDecisionChampsObligatoiresFilled[v] = true);
                Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(v =>
                    this.reclamerUneSommeChampsObligatoiresFilled[v] = true);
                Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(v =>
                        this.contesterUneSommeChampsObligatoiresFilled[v] = true);
                Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(v =>
                            this.indemnisationChampsObligatoiresFilled[v] = true);
            }
        } else {
            Object.keys(this.sociauxDALOChampsObligatoiresFilled).forEach(v => this.sociauxDALOChampsObligatoiresFilled[v] = true);
            Object.keys(this.litigeLieDecisionChampsObligatoiresFilled).forEach(v =>
                this.litigeLieDecisionChampsObligatoiresFilled[v] = true);
            Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(v =>
                this.reclamerUneSommeChampsObligatoiresFilled[v] = true);
            Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(v =>
                    this.contesterUneSommeChampsObligatoiresFilled[v] = true);
            Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(v =>
                        this.indemnisationChampsObligatoiresFilled[v] = true);
        }
        this.updateSectionsIndiceAndVisibility(changes.depotRequeteState.currentValue);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.dragSubscription.unsubscribe();
        this.dropSubscription.unsubscribe();
        super.ngOnDestroy();
    }

    get isActeAttaquesMaxSizeExceeded(): boolean {
        return (
            this.depotRequeteState.acteAttaquesAFusioner.reduce((acc, aa) => acc + aa.fileModel.fileSize, 0) >
            this.maxFileSize
        );
    }

    updateSectionsIndiceAndVisibility(depotRequeteState: any) {
        if (depotRequeteState.formActivated) {
            if (depotRequeteState.urgenceRequete && depotRequeteState.urgenceRequete.codeUrgence === 0) {
                if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                    this.setAllSectionsInvisibleExceptSouhait();
                    if (this.contentieuxSocial.souhait) {
                        this.setSectionVisibilityBySouhait(this.contentieuxSocial.souhait);
                    }
                } else {
                    if (depotRequeteState.concernContentieuxSocial == null) {
                        this.setAllSectionsInvisible();
                    } else if (depotRequeteState.concernContentieuxSocial === true) {
                        this.showSociauxDALOSections();
                    } else {
                        this.showRapoSection = false;
                        this.showSouhaitSection = true;
                        this.showMotifSection = false;
                        this.showDALOConclusionSection = false;
                        this.setSectionVisibilityBySouhait(this.contentieuxSocial.souhait);
                        if (this.depotRequeteState.requeteCS &&
                            this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
                            this.setSectionVisibilityByTypeLitige(this.depotRequeteState.requeteCS.typeLitige);
                            if (this.depotRequeteState.requeteCS.typeLitige ===
                                'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                    this.setSectionVisibilityByTypeActe(this.depotRequeteState.requeteCS.typeActe);
                            }
                        }
                    }
                }
            } else {
                this.setAllSectionsInvisible();
            }
        } else {
            if (depotRequeteState.urgenceRequete && depotRequeteState.urgenceRequete.codeUrgence === 0) {
                if (depotRequeteState.concernContentieuxSocial === true) {
                    this.showSociauxDALOSections();
                } else {
                    this.setAllSectionsInvisible();
                }
            } else {
                this.setAllSectionsInvisible();
            }
        }
    }

    private showSociauxDALOSections(): void {
        this.showRapoSection = true;
        this.showDecisionAttaqueSection = true;
        this.showNomAdministrationsSection = true;
        this.showIntituleDemandeSection = true;
        this.showMotifSection = true;
        this.showDALOConclusionSection = true;
        this.showConclusionLitigeAdminSection = false;
        this.showTypeLitigeSection = false;
        this.showFaitConduitLitigeSection = false;
        this.showTypeActeEmisSection = false;
        this.showAvisImpositionIrregulerSection = false;
        this.showRaisonPasPayerImpotSection = false;
        this.showTitreEmisIrregulerSection = false;
        this.showReclamationPrealableSection = false;
        this.showSouhaitSection = false;
        this.showContexteInterventionDecision = false;
        this.showRaisonsContesterDecisionSection = false;
        this.showSommeDueSection = false;
        this.showMontantDuSection = false;
        this.showConclusionReclamerSommeSection = false;
        this.showConclusionAvisImpositionImpotSection = false;
        this.showConclusionTitreEmisIrregulerSection = false;
        this.showFaitConduitSituationReparationSection = false;
        this.showTypePrejudiceEvaluableEnArgentSection = false;
        this.showPrecisionPrejudiceSection = false;
        this.showOriginePrejudiceSection = false;
        this.showConclusionIndemnisationSection = false;
        this.showRequeteRedigeeSection = false;
        this.showRequeteRedigeeJustificatifsSection = false;
        this.sections.hasDecisionAttaque.index = 4;
        this.sections.administrationDecision.index = 5;
        this.sections.intituleDemande.index = 6;
        this.sections.motifDemande.index = 7;
        this.sections.conclusionDALO.index = 8;
    }

    registerOnChange(fn: any): void {
        super.registerOnChange(fn);
    }

    protected modelValueChanged(value: ContentieuxSocial): void {
        this.contentieuxSocial = value || new ContentieuxSocial();
            if (value && value.hasDocument) {
                this.contentieuxSocial.raisonSansDocument = '';
            }
    }

    clearDecisionAttaqueeJointPiece(value: any): void {
        console.log('clearDecisionAttaqueJointPiece value', value)
        if (value !== null) {
            this.depotRequeteState.acteAttaquesAFusioner.length = 0;
        }
    }
    onContentieuxSocialChange() {
        this.onChange(this.contentieuxSocial);
    }

    onSetSouhait(value: any) {
        this.clearRequete();
        if (value === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            this.showLitigeAvocat = true;
        }else {
            this.showLitigeAvocat = false;
        }
        if (this.souhaitTexts.find(s => s.description === value)) {
            this.contentieuxSocial.souhait = this.souhaitTexts.find(s => s.description === value).description as string;
            this.onContentieuxSocialChange();
        }
        Object.keys(this.litigeLieDecisionChampsObligatoiresFilled).forEach(v =>
            this.litigeLieDecisionChampsObligatoiresFilled[v] = true);
        Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(v =>
            this.reclamerUneSommeChampsObligatoiresFilled[v] = true);
        Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(v =>
                this.contesterUneSommeChampsObligatoiresFilled[v] = true);
        Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(v =>
                    this.indemnisationChampsObligatoiresFilled[v] = true);

        this.setSectionVisibilityBySouhait(value);
    }

    clearRequete(): void {
        if (this.depotRequeteState.requete) {
            this.depotRequeteState.requete = null!;
        }
    }

    setSectionVisibilityBySouhait(checkedSouhait: string) {
        if (checkedSouhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            this.showTypeLitigeSection = true;
            this.showReclamationPrealableSection = false;
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.typeLitige.index = 3
            } else {
                this.sections.typeLitige.index = 4;
            }

            this.setSectionVisibilityByTypeLitige(this.contentieuxSocial.typeLitige);

            this.showLitigeAvocat = true;
        } else if (checkedSouhait === 'Déposer une requête que vous avez rédigée') {
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showTypeLitigeSection = false;
            this.showDecisionAttaqueSection = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showDALOConclusionSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showReclamationPrealableSection = true;
            this.showRequeteRedigeeSection = true;
            this.showRequeteRedigeeJustificatifsSection = true;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.requeteRedigeeDecisionAttaque.index = 3;
                this.sections.reclamationPrealable.index = 4;
                this.sections.depotRequeteRedigee.index = 5;
                this.sections.requeteRedigeeJustificatifs.index = 6;
            } else {
                this.sections.requeteRedigeeDecisionAttaque.index = 4;
                this.sections.reclamationPrealable.index = 5;
                this.sections.depotRequeteRedigee.index = 6;
                this.sections.requeteRedigeeJustificatifs.index = 7;
            }
            this.showLitigeAvocat = false;
        } else if (checkedSouhait === 'Remplir le formulaire : litige lié à une décision de l\'administration') {
            this.showDecisionAttaqueSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showContexteInterventionDecision = true;
            this.showRaisonsContesterDecisionSection = true;
            this.showConclusionLitigeAdminSection = true;
            this.showDALOConclusionSection = false;
            this.showTypeLitigeSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showReclamationPrealableSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.hasDecisionAttaque.index = 3;
                this.sections.administrationDecision.index = 4;
                this.sections.intituleDemande.index = 5;
                this.sections.contexteInterventionDecision.index = 6;
                this.sections.raisonsContesterDecision.index = 7;
                this.sections.conclusionLitigeAdmin.index = 8;

            } else {
                this.sections.hasDecisionAttaque.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.contexteInterventionDecision.index = 7;
            }
            this.showLitigeAvocat = false;
            // arrive pour la 1ère fois au formulaire
        } else {
            this.showDecisionAttaqueSection = false;
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showDALOConclusionSection = false;
            this.showTypeLitigeSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showReclamationPrealableSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            this.showLitigeAvocat = false;
        }
    }

    onSetTypeLitige(value: any) {
        if (this.reclamationPrealableComponent) {
            this.reclamationPrealableComponent.markAsUntouched();
        }
        if (this.typeLitigeTexts.find(t => t.title === value)) {
            this.contentieuxSocial.typeLitige = this.typeLitigeTexts.find(t => t.title === value).title as string;
            console.log('onSetTypeLitige | typeLitige ', this.contentieuxSocial.typeLitige);
            this.onContentieuxSocialChange();
        }
        this.setSectionVisibilityByTypeLitige(value);
        Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(v =>
            this.reclamerUneSommeChampsObligatoiresFilled[v] = true);
        Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(v =>
            this.contesterUneSommeChampsObligatoiresFilled[v] = true);
        Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(v =>
                this.indemnisationChampsObligatoiresFilled[v] = true);
    }

    setSectionVisibilityByTypeLitige(checkedTypeLitige: string) {
        if (!checkedTypeLitige) {
            this.showReclamationPrealableSection = false;
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
        } else if (checkedTypeLitige === 'Vous réclamez une somme d\'argent à l\'administration') {
            this.showReclamationPrealableSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showContexteInterventionDecision = true;
            this.showSommeDueSection = true;
            this.showMontantDuSection = true;
            this.showConclusionReclamerSommeSection = true;
            this.showRaisonsContesterDecisionSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.reclamationPrealable.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.contexteInterventionDecision.index = 7;
                this.sections.sommeDueSection.index = 8;
                this.sections.montantDuSection.index = 9;
                this.sections.conclusionReclamerSommeSection.index = 10;
            } else {
                this.sections.reclamationPrealable.index = 5;
                this.sections.administrationDecision.index = 6;
                this.sections.intituleDemande.index = 7;
                this.sections.contexteInterventionDecision.index = 8;
                this.sections.sommeDueSection.index = 9;
                this.sections.montantDuSection.index = 10;
                this.sections.conclusionReclamerSommeSection.index = 11;
            }
        } else if (checkedTypeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration') {
            this.showReclamationPrealableSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showFaitConduitLitigeSection = true;
            this.showTypeActeEmisSection = true;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showContexteInterventionDecision = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.reclamationPrealable.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.faitConduitLitigeSection.index = 7;
                this.sections.typeActeEmisSection.index = 8;

            } else {
                this.sections.reclamationPrealable.index = 5;
                this.sections.administrationDecision.index = 6;
                this.sections.intituleDemande.index = 7;
                this.sections.contexteInterventionDecision.index = 8;
            }
            this.setSectionVisibilityByTypeActe(this.contentieuxSocial.typeActe);
        } else {
            this.showReclamationPrealableSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showFaitConduitSituationReparationSection = true;
            this.showTypePrejudiceEvaluableEnArgentSection = true;
            this.showPrecisionPrejudiceSection = true;
            this.showOriginePrejudiceSection = true;
            this.showConclusionIndemnisationSection = true;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showContexteInterventionDecision = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDecisionAttaqueSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.reclamationPrealable.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.faitConduitSituationReparationSection.index = 7;
                this.sections.typePrejudiceEvaluableEnArgentSection.index = 8;
                this.sections.precisionPrejudiceSection.index = 9;
                this.sections.originePrejudiceSection.index = 10;
                this.sections.conclusionIndemnisationSection.index = 11;
            } else {
                this.sections.reclamationPrealable.index = 5;
                this.sections.administrationDecision.index = 6;
                this.sections.intituleDemande.index = 7;
                this.sections.faitConduitSituationReparationSection.index = 8;
                this.sections.typePrejudiceEvaluableEnArgentSection.index = 9;
                this.sections.precisionPrejudiceSection.index = 10;
                this.sections.originePrejudiceSection.index = 11;
                this.sections.conclusionIndemnisationSection.index = 12;
            }
        }
    }
    onSetTypeActe(value: any) {
        console.log('onSetTypeActe checked type acte ', value)
        if (this.typeActeEmisTexts.find(t => t.title === value)) {
            this.contentieuxSocial.typeActe = this.typeActeEmisTexts.find(t => t.title === value).title as string;
            if (value === 'Un avis d\'imposition') {
                this.typeActeAdderLabel = 'Avis d\'imposition';
            } else {
                this.typeActeAdderLabel = 'Acte émis par l\'administration';
            }
            this.onContentieuxSocialChange();
        }
        // enlève pièces complémentaires avis imposition erreur calcul ou infondee et autre si existe
        this.pieceComplmentaireAvisImpositionInfondeeEtAutre.length = 0;
        this.depotRequeteState.piecesComplementaires = this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType !== PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE);

        this.contesterUneSommeChampsObligatoiresFilled.raisonAvisDimpositionIrreguliers = true;
        this.contesterUneSommeChampsObligatoiresFilled.conclusionAvisImpositionImpot = true;
        this.contesterUneSommeChampsObligatoiresFilled.avisImpositionErreurCalcul = true;
        this.contesterUneSommeChampsObligatoiresFilled.raisonPasPayerImpot = true;
        this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitres = true;
        this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitreDetail = true;
        this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierDes = true;
        this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierMontant = true;
        this.setSectionVisibilityByTypeActe(value);
    }

    setSectionVisibilityByTypeActe(checkedTypeActe: string) {
        if (!checkedTypeActe) {
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showRaisonPasPayerImpotSection = false;

        } else if (checkedTypeActe === 'Un avis d\'imposition') {
            this.typeActeAdderLabel = 'Avis d\'imposition';
            this.showAvisImpositionIrregulerSection = true;
            this.showRaisonPasPayerImpotSection = true;
            this.showConclusionAvisImpositionImpotSection = true;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.avisImpositionIrregulerSection.index = 9;
                this.sections.raisonPasPayerImpotSection.index = 10;
                this.sections.conclusionAvisImpositionImpotSection.index = 11;
            } else {
                this.sections.avisImpositionIrregulerSection.index = 10;
                this.sections.raisonPasPayerImpotSection.index = 11;
                this.sections.conclusionAvisImpositionImpotSection.index = 12;
            }
        } else {
            this.typeActeAdderLabel = 'Acte émis par l\'administration';
            this.showTitreEmisIrregulerSection = true;
            this.showConclusionTitreEmisIrregulerSection = true;
            this.showAvisImpositionIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showRaisonPasPayerImpotSection = false;

            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.titreEmisIrregulerSection.index = 9;
                this.sections.conclusionTitreEmisIrregulerSection.index = 10;
            } else {
                this.sections.titreEmisIrregulerSection.index = 10;
                this.sections.conclusionTitreEmisIrregulerSection.index = 11;
            }
        }
    }

    reclamerSommeNomAdminsFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
        !this.reclamerUneSommeChampsObligatoiresFilled.nomsAdministrations &&
        this.contentieuxSocial.nomsAdministrations == null;
    }

    reclamerSommeObjectDemandeFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
        !this.reclamerUneSommeChampsObligatoiresFilled.objetDemande &&
        this.contentieuxSocial.objetDemande == null;
    }

    reclamerSommeContexteInterventionDecisionFilled(): boolean {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
        !this.reclamerUneSommeChampsObligatoiresFilled.contexteInterventionDecision &&
        this.contentieuxSocial.contexteInterventionDecision == null;
    }

    reclamerSommePourquoiSommeDueFilled(): boolean {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
        !this.reclamerUneSommeChampsObligatoiresFilled.pourquoiSommeDue &&
        this.contentieuxSocial.pourquoiSommeDue == null;
    }

    reclamerSommeMontantDuMontantFilled(): boolean {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
        !this.reclamerUneSommeChampsObligatoiresFilled.montantDuMontant &&
        this.contentieuxSocial.montantDuMontant == null;
    }

    reclamerSommeConclusionFilled(): boolean {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
        !this.reclamerUneSommeChampsObligatoiresFilled.conclusionReclamerSommeCondamnerAdmin &&
        !this.contentieuxSocial.conclusionReclamerSommeCondamnerAdmin;
    }

    contesterSommeNomAdminsFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        !this.contesterUneSommeChampsObligatoiresFilled.nomsAdministrations &&
        this.contentieuxSocial.nomsAdministrations == null;
    }

    contesterSommeObjectDemandeFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        !this.contesterUneSommeChampsObligatoiresFilled.objetDemande &&
        this.contentieuxSocial.objetDemande == null;
    }

    contesterSommeFaitConduitAuLitigeFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        !this.contesterUneSommeChampsObligatoiresFilled.faitConduitAuLitige &&
        this.contentieuxSocial.faitConduitAuLitige == null;
    }

    contesterSommeRaisonPasPayerImpotFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        this.contentieuxSocial.typeActe === 'Un avis d\'imposition' &&
        !this.contesterUneSommeChampsObligatoiresFilled.raisonPasPayerImpot &&
        this.contentieuxSocial.raisonPasPayerImpot == null;
    }

    contesterSommeConclusionAvisImpositionImpotFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        this.contentieuxSocial.typeActe === 'Un avis d\'imposition' &&
        !this.contesterUneSommeChampsObligatoiresFilled.conclusionAvisImpositionImpot &&
        this.contentieuxSocial.conclusionAvisImpositionImpot == null;
    }

    contesterSommeConclusionContesterSommeTitreEmisIrregulierDesFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        this.contentieuxSocial.typeActe === 'Un titre de recette, un avis de somme à payer, ou autre' &&
        !this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierDes &&
        this.contentieuxSocial.conclusionContesterSommeTitreEmisIrregulierDes == null;
    }

    contesterSommeConclusionContesterSommeTitreEmisIrregulierMontantFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
        this.contentieuxSocial.typeActe === 'Un titre de recette, un avis de somme à payer, ou autre' &&
        !this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierMontant &&
        this.contentieuxSocial.conclusionContesterSommeTitreEmisIrregulierMontant == null;
    }

    indemnisationNomAdminsFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.nomsAdministrations &&
        this.contentieuxSocial.nomsAdministrations == null;
    }

    indemnisationObjetDemandeFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.objetDemande &&
        this.contentieuxSocial.objetDemande == null;
    }

    indemnisationFaitConduitSituationReparationFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.faitConduitSituationReparation &&
        this.contentieuxSocial.faitConduitSituationReparation == null;
    }

    indemnisationPrecisionPrejudiceFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.precisionPrejudice &&
        this.contentieuxSocial.precisionPrejudice == null;
    }

    indemnisationOriginePrejudiceFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.originePrejudice &&
        this.contentieuxSocial.originePrejudice == null;
    }

    indemnisationConclusionIndemnisationCondamnerAdminFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationCondamnerAdmin &&
        this.contentieuxSocial.conclusionIndemnisationCondamnerAdmin == null;
    }

    indemnisationConclusionIndemnisationMontantFilled(): boolean {
        return !this.depotRequeteState.concernContentieuxSocial &&
        this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
        this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
        ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
        !this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationMontant &&
        this.contentieuxSocial.conclusionIndemnisationMontant == null;
    }

    onRAPOChange(file: FileUploaderModel) {
        if (file) {
            // clear the pieces complementaires array first
            this.pieceComplementaireRAPO = undefined;
            this.depotRequeteState.piecesComplementaires.push(
                new PieceComplementaire(file, PieceJointType.PIECE_JOINTE_REQUETE, PieceComplementaireOrigineType.RAPO)
            );
        }
    }
    onRequeteRedigeeChange(file: FileUploaderModel) {
        if (file) {
            // clear exist requete first
            this.depotRequeteState.requete = null!;
            this.depotRequeteState.requete = new PieceRequete(file);
        }
    }

    resetGeneratedActeAttaque() {
        this.depotRequeteState.acteAttaque = new PieceActeAttaque(null);
    }

    resetGeneratedReclamationPrealable() {
        this.depotRequeteState.reclamationPrealable = new PieceReclamationPrealable(null);
    }

    get isReclamationPrealablesMaxSizeExceeded(): boolean {
        return (
            this.depotRequeteState.reclamationPrealablesAFusioner.reduce((acc, aa) => acc + aa.fileModel.fileSize, 0) >
            this.maxFileSize
        );
    }
    onRaisonContestationCheck() {
       const checkedRC = this.typeRaisonContestations.filter(rct => rct.checked);
       this.contentieuxSocial.raisonContestations = checkedRC.map(rc => ({typeRaisonContestationId: rc.id, detail: rc.detail}));
       this.onContentieuxSocialChange();
       if (this.contentieuxSocial.raisonContestations.length === 0) {
        this.noneRCchecked = true;
       } else {
        this.noneRCchecked = false;
       }
    }

    noRaisonContestationChecked(): boolean {
        return this.typeRaisonContestations.some(t => t.checked);
    }

    onRaisonInvalidationTitreCheck() {
        const checkedRIT = this.typeRaisonInvalidationTitres.filter(rit => rit.checked);
        this.contentieuxSocial.raisonInvalidationTitres = checkedRIT.map(rit =>
            ({typeRaisonInvalidationTitreId: rit.id, detail: rit.detail}));
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.raisonInvalidationTitres.length === 0) {
         this.noneRITchecked = true;
        } else {
         this.noneRITchecked = false;
        }
    }

    noRaisonInvalidationTitreChecked(): boolean {
        return this.typeRaisonInvalidationTitres.some(t => t.checked);
    }

    onRaisonAvisDimpositionIrregulierCheck() {
        const checkedRADI = this.typeRaisonAvisDimpositionIrreguliers.filter(r => r.checked);
        this.contentieuxSocial.raisonAvisDimpositionIrreguliers = checkedRADI.map(r => ({typeRaisonAvisDimpositionIrregulierId: r.id}));
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.raisonAvisDimpositionIrreguliers.length === 0) {
            this.noneRADIchecked = true;
        } else {
            this.noneRADIchecked = false;
        }
    }

    noRaisonAvisDimpositionIrregulierChecked(): boolean {
        return this.typeRaisonAvisDimpositionIrreguliers.some(r => r.checked);
    }

    onPrejudiceEvaluableEnArgentCheck() {
        const checkedPEEA = this.typePrejudiceEvaluableEnArgents.filter(p => p.checked);
        this.contentieuxSocial.prejudiceEvaluableEnArgents = checkedPEEA.map(p => ({typePrejudiceEvaluableEnArgentId: p.id}));
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.prejudiceEvaluableEnArgents.length === 0) {
            this.nonePEEAchecked = true;
        } else {
            this.nonePEEAchecked = false;
        }
    }

    noPrejudiceEvaluableEnArgentChecked(): boolean {
        return this.typePrejudiceEvaluableEnArgents.some(t => t.checked);
    }

    sansRaisonDisabled(): boolean {
        return this.depotRequeteState.requeteCS == null
        || this.depotRequeteState.requeteCS.hasDocument == null
        || this.contentieuxSocial.hasDocument
    }

    openWarningModal(modal) {
        this.modalReference = this.modalService.open(modal, { size: 'lg'});
        this.modalReference.result.then((_) => {
            this.modalReference.close();
        },
        _ => {
            this.modalReference.close();
        });
        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Avertissement');
    }
    onPieceComplementaireDelete(index: number, file: FileUploaderModel, piecesComplementaires: PieceComplementaire[]) {
        if (!file) {
            // delete from piecesComplementaires;
            const piece = piecesComplementaires[index];
            piecesComplementaires.splice(index, 1);

            // delete from depotRequeteState.piecesComplementaires
            const idxInStatePC = this.depotRequeteState.piecesComplementaires.indexOf(piece);
            this.depotRequeteState.piecesComplementaires.splice(idxInStatePC, 1);
        }
    }

    onPieceComplementaireMIAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireMalInterprete,
                PieceComplementaireOrigineType.MAL_INTERPRETE, this.pieceMIAdder);
        }
    }

    onPieceComplementaireMAAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireMalApprecie,
                PieceComplementaireOrigineType.MAL_APPRECIE, this.pieceMAAdder);
        }
    }

    onPieceComplementaireSommeDueAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireSommeDue,
                PieceComplementaireOrigineType.SOMME_DUE, this.pieceSommeDueAdder);
        }
    }

    onPieceComplementaireMontantDuAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireMontantDu,
                PieceComplementaireOrigineType.MONTANT_DU, this.pieceMontantDuAdder);
        }
    }

    onPieceComplementaireAIIAAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplmentaireAvisImpositionInfondeeEtAutre,
                PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE, this.pieceAIIAAdder);
        }
    }

    onPieceComplementairePrecisionPrejudiceAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementairePrecisionPrejudice,
                PieceComplementaireOrigineType.PRECISION_PREJUDICE, this.piecePrecisionPrejudiceAdder);
        }
    }

    onPieceComplementaireRequeteRedigeeJustAdd(file: FileUploaderModel) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireRequeteRedigeeJust,
                PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF, this.pieceRequeteRedigeeJustAdder);
        }
    }

    private addPieceComplementaire(file: FileUploaderModel, pieceList: Array<PieceComplementaire>,
        originType: PieceComplementaireOrigineType, pieceAdder: FileUploaderComponent) {
        pieceList.push(
            new PieceComplementaire(file, PieceJointType.PIECE_JOINTE_REQUETE, originType));
        this.depotRequeteState.piecesComplementaires.push(
            new PieceComplementaire(file, PieceJointType.PIECE_JOINTE_REQUETE, originType));
        pieceAdder.deleteFile();
    }

    checkLengthForFileName(value: string, file: PieceComplementaire) {
        if (value) {
            this.actualFileNameLength = value.length;
            this.showLengthWarningForFileName = value.length > this.maxFileNameWithoutExtensionLength;
            if (!this.showLengthWarningForFileName) {
                const piece = this.depotRequeteState.piecesComplementaires.find(pc => pc.fileModel === file.fileModel);
                if (piece) {
                    piece.libelle = file.libelle;
                }
            }
        }
    }

    // @ts-ignore
    trackByFileApiId(index: number, item: PieceComplementaire) {
        return item.fileModel.fileApiId;
    }

    // --- drag n drop keyboard accessible
    onMoveup(data: any, pieceComplementaire: Array<PieceComplementaire>) {
        this.moveUp(data.i, pieceComplementaire);
    }

    onMovedown(data: any, pieceComplementaire: Array<PieceComplementaire>) {
        this.moveDown(data.i, pieceComplementaire);
    }

    moveUp(index: number, pieceComplementaire: Array<PieceComplementaire>) {
        if (index > 0) {
            this.swapPiecesComplementaire(index - 1, index, pieceComplementaire);
        }
    }

    moveDown(index: number, pieceComplementaire: Array<PieceComplementaire>) {
        if (index < pieceComplementaire.length - 1) {
            this.swapPiecesComplementaire(index + 1, index, pieceComplementaire);
        }
    }

    private swapPiecesComplementaire(piece1Index: number, piece2Index: number, pieceComplementaire: Array<PieceComplementaire>) {
        const piece1 = pieceComplementaire[piece1Index];
        const piece2 = pieceComplementaire[piece2Index];
        const idxPiece1 = this.depotRequeteState.piecesComplementaires.indexOf(piece1);
        const idxPiece2 = this.depotRequeteState.piecesComplementaires.indexOf(piece2);
        pieceComplementaire[piece2Index] = piece1;
        pieceComplementaire[piece1Index] = piece2;
        this.depotRequeteState.piecesComplementaires[idxPiece2] = piece1;
        this.depotRequeteState.piecesComplementaires[idxPiece1] = piece2;
    }
    onSelectMI(data: any) {
        console.log('onSelectMI', data);
        this.selectedItemMI = data.piece.fileModel.fileApiId;
    }

    onEscapeMI(data: any) {
        console.log('onEscapeMI', data);
        this.selectedItemMI = null;
    }

    onSelectMA(data: any) {
        console.log('onSelectMA', data);
        this.selectedItemMA = data.piece.fileModel.fileApiId;
    }

    onEscapeMA(data: any) {
        console.log('onEscapeMA', data);
        this.selectedItemMA = null;
    }

    onSelectSommeDue(data: any) {
        console.log('onSelectSommeDue', data);
        this.selectedItemSommeDue = data.piece.fileModel.fileApiId;
    }

    onEscapeSommeDue(data: any) {
        console.log('onEscapeSommeDue', data);
        this.selectedItemSommeDue = null;
    }

    onSelectMontantDu(data: any) {
        console.log('onSelectMontantDu', data);
        this.selectedItemMontantDu = data.piece.fileModel.fileApiId;
    }

    onEscapeMontantDu(data: any) {
        console.log('onEscapeMontantDu', data);
        this.selectedItemMontantDu = null;
    }

    onSelectAIEC(data: any) {
        console.log('onSelectAIEC', data);
        this.selectedItemAIEC = data.piece.fileModel.fileApiId;
    }

    onEscapeAIEC(data: any) {
        console.log('onEscapeAIEC', data);
        this.selectedItemAIEC = null;
    }

    onSelectAIIA(data: any) {
        console.log('onSelectAIIA', data);
        this.selectedItemAIIA = data.piece.fileModel.fileApiId;
    }

    onEscapeAIIA(data: any) {
        console.log('onEscapeAIIA', data);
        this.selectedItemAIIA = null;
    }

    onSelectPrecisionPrejudice(data: any) {
        console.log('onSelectPrecisionPrejudice', data);
        this.selectedItemPrecisionPrejudice = data.piece.fileModel.fileApiId;
    }

    onEscapePrecisionPrejudice(data: any) {
        console.log('onEscapePrecisionPrejudice', data);
        this.selectedItemPrecisionPrejudice = null;
    }

    onSelectRequeteRedigeeJust(data: any) {
        console.log('onSelectRequeteRedigeeJust', data);
        this.selectedItemRRJ = data.piece.fileModel.fileApiId;
    }

    onEscapeRequeteRedigeeJust(data: any) {
        console.log('onEscapeRequeteRedigeeJust', data);
        this.selectedItemRRJ = null;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requete/contentieux-social-section/contentieux-social-section.component.ts